import { customFetch, appendFormDataWithObjectValues } from 'utils/http';
import { HTTPResponseError } from 'utils/errors';
import { getM8AdminURL } from 'services/production/utils/getM8URL';

type Params = {
  idPrice: number;
};

export const deletePrice = async (params: Params): Promise<void> => {
  const body = new FormData();

  appendFormDataWithObjectValues(body, params);

  const response = await customFetch(getM8AdminURL('deletePrice'), {
    method: 'DELETE',
    body,
  });

  if (!response.ok) {
    throw new HTTPResponseError(response);
  }
};
